import React, { useState, useMemo, useContext, useCallback } from "react";
import useStyles from "../../styles/components/Modals/LoginModalStyles";
import ModalCloseSVGR from "../../smart-assets/SVGRs/ModalCloseSVGR";
import { Grid, Typography, Button } from "@material-ui/core";
import Modal from '@material-ui/core/Modal';
import TextFieldWithStatus from "../TextFieldWithStatus";
import TextFieldPassword from "../TextFieldPassword";
import { UserContext } from "../../contexts/UserContext";
import { useHistory } from "react-router-dom";
import useLanguage from "../../hooks/useLanguage";
import useAuth from "../../hooks/services/useAuth";
import classNames from "classnames";
import SMSInputWithStatus from "../SMSInputWithStatus"

const Header = (props) => {
    const classes = useStyles(props);
    const { isOpen, onClose } = props;
    const { fetchUser, setUser } = useContext(UserContext);
    const { checkAuthState, requestSMS, firstAuth, firstPasswordChange, login, requestVerifyAuthSMS, verifyAuthSMS, authPasswordRecovery, requestPasswordRecoverySMS } = useAuth();
    const history = useHistory();

    const { globalComponents: { loginModal: STRINGS } } = useLanguage();


    const [userData, setUserData] = useState(false);
    const [physicalID, setPhysicalID] = useState('');
    const [physicalIDStatus, setPhysicalIDStatus] = useState(null);
    const [physicalIDError, setPhysicalIDError] = useState('');
    const [cardLastFourNumbersStatus, setCardLastFourNumbersStatus] = useState(null);
    const [cardLastFourNumbers, setCardLastFourNumbers] = useState('');
    const [cardLastFourNumbersError, setCardLastFourNumbersError] = useState('')
    const [smsCode, setSMSCode] = useState('');
    const [smsCodeStatus, setSMSCodeStatus] = useState('');
    const [smsCodeTimeoutKey, setSMSCodeTimeoutKey] = useState(null);
    const [smsCodeError, setSMSCodeErorr] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [currentlyRequesting, setCurrentlyRequesting] = useState(false);
    const [authState, setAuthState] = useState(null);
    const [sentSMSAt, setSentSMSAt] = useState(null);
    const [smsTimeout, setSMSTimeout] = useState(0);
    const [resettingPassword, setResettingPassword] = useState(false);

    const nullifyValues = useCallback(() => {
        setUserData(false);
        setPhysicalID('');
        setPhysicalIDStatus(null);
        setPhysicalIDError('');
        setCardLastFourNumbersStatus(null);
        setCardLastFourNumbers('');
        setCardLastFourNumbersError('');
        setSMSCode('');
        setSMSCodeStatus('');
        setSMSCodeTimeoutKey(null);
        setSMSCodeErorr('');
        setPassword('');
        setPasswordError('');
        setRepeatPassword('');
        setCurrentlyRequesting(false);
        setAuthState(null);
        setSentSMSAt(null);
        setSMSTimeout(0);
        setResettingPassword(false);
    }, [setPhysicalID, setPhysicalIDStatus, setPhysicalIDError, setCardLastFourNumbersStatus, setCardLastFourNumbers, setCardLastFourNumbersError, 
    setSMSCode, setSMSCodeStatus, setSMSCodeTimeoutKey, setSMSCodeErorr, setPassword, setPasswordError, setRepeatPassword, setCurrentlyRequesting,setAuthState,
    setSentSMSAt, setSMSTimeout, setResettingPassword])

    const verify = useCallback(async () => {
        console.log(smsTimeout, !sentSMSAt || (new Date().getTime() - sentSMSAt.getTime()) / 1000 > smsTimeout)
        if (!sentSMSAt || (new Date().getTime() - sentSMSAt.getTime()) / 1000 > smsTimeout) {
            const data = await requestVerifyAuthSMS();
            console.log('data', data);
            if (data.status === 200) {
                setSentSMSAt(new Date());
            }
            setSMSTimeout(data.data.data);
            if (smsCodeTimeoutKey) {
                clearTimeout(smsCodeTimeoutKey)
            }
            const key = setTimeout(() => {
                setSentSMSAt(false)
            }, data.data.data * 1000);
            setSMSCodeTimeoutKey(key);
        }
    }, [requestVerifyAuthSMS, sentSMSAt, smsCodeTimeoutKey, smsTimeout])

    const handleLogin = useCallback(async (notFirst = false) => {
        setCurrentlyRequesting(true)
        const res = await login(physicalID, password);
        console.log(res.status);
        if (res.status === 200) {
            const data = await fetchUser();
            console.log("DATA", data);
            if (notFirst) {
                setUserData(data);
                verify();
            }
            else {
                setUser(data);
                nullifyValues();
                history.push('/account');
                onClose();
            }

        }
        else {
            // TODO - set password Error
            console.log('here')
            setPasswordError(STRINGS.errors.wrongPassword);
        }
        setCurrentlyRequesting(false)
    }, [login, physicalID, password, fetchUser, verify, setUser, nullifyValues, history, onClose, STRINGS.errors.wrongPassword])

    const verifyAuth = useCallback(async (smsCode) => {
        const res = await verifyAuthSMS(smsCode);
        console.log("RES", res)
        if (res.error) {
            switch (res.error) {
                case "SMS_VERIFY_ERROR":
                    setSMSCodeStatus('fail')
                    setSMSCodeErorr(STRINGS.errors.wrongSMSCode)
                    break;
                case "CARD_VERIFY_ERROR":
                    setCardLastFourNumbersStatus('fail');
                    setCardLastFourNumbersError(STRINGS.errors.cardLastFourNumbersNotFound);
                    if (smsCodeTimeoutKey) {
                        clearTimeout(smsCodeTimeoutKey)
                    }
                    setSentSMSAt(false)
                    break;
                default:
                    break;
            }
        }
        else if (res.status === 0) {
            setCardLastFourNumbersStatus('success')
            setSMSCodeStatus('success')
            // const fpcRes = await firstPasswordChange(password, repeatPassword);
            // console.log('fpcRes', fpcRes);
            // setUser(userData);
            const { data } = await fetchUser();
            console.log("DATA", data);
            setUser(data);
            nullifyValues();
            history.push('/account');
            onClose();
        }
    }, [STRINGS.errors.cardLastFourNumbersNotFound, STRINGS.errors.wrongSMSCode, fetchUser, history, nullifyValues, onClose, setUser, smsCodeTimeoutKey, verifyAuthSMS])


    const handleFirstTimeLogin = useCallback(async () => {
        setCurrentlyRequesting(true);

        setCardLastFourNumbersStatus('loading')
        setSMSCodeStatus("loading");

        console.log(physicalID, smsCode, cardLastFourNumbers, password, repeatPassword)
        const faRes = await firstAuth(physicalID, smsCode, cardLastFourNumbers);
        console.log('faRes', faRes);

        setCardLastFourNumbersError('')
        setCardLastFourNumbersStatus(null)

        setSMSCodeErorr('')
        setSMSCodeStatus(null);



        if (faRes.error) {
            switch (faRes.error) {
                case "SMS_VERIFY_ERROR":
                    setSMSCodeStatus('fail')
                    setSMSCodeErorr(STRINGS.errors.wrongSMSCode)
                    break;
                case "CARD_VERIFY_ERROR":
                    setCardLastFourNumbersStatus('fail');
                    setCardLastFourNumbersError(STRINGS.errors.cardLastFourNumbersNotFound);
                    if (smsCodeTimeoutKey) {
                        clearTimeout(smsCodeTimeoutKey)
                    }
                    setSentSMSAt(false)
                    break;
                default:
                    break;
            }
        }
        else if (faRes.status === 0) {
            setCardLastFourNumbersStatus('success')
            setSMSCodeStatus('success')
            const fpcRes = await firstPasswordChange(password, repeatPassword);
            console.log('fpcRes', fpcRes);
            if (fpcRes.status === 0) {
                // await handleLogin(false)
                nullifyValues();
            }
        }
        setCurrentlyRequesting(false);
    }, [physicalID, smsCode, cardLastFourNumbers, password, repeatPassword, firstAuth, STRINGS.errors.wrongSMSCode, STRINGS.errors.cardLastFourNumbersNotFound, smsCodeTimeoutKey, firstPasswordChange, nullifyValues]);

    const _sendSMS = useCallback(async () => {
        console.log(smsTimeout)
        if (!sentSMSAt || (new Date().getTime() - sentSMSAt.getTime()) / 1000 > smsTimeout) {
            const data = await requestSMS(physicalID);
            console.log('data', data);
            if (data.status === 200) {
                setSentSMSAt(new Date());
            }
            setSMSTimeout(data.data.data);
            if (smsCodeTimeoutKey) {
                clearTimeout(smsCodeTimeoutKey)
            }
            const key = setTimeout(() => {
                setSentSMSAt(false)
            }, data.data.data * 1000);
            setSMSCodeTimeoutKey(key);
        }
    }, [physicalID, requestSMS, sentSMSAt, smsCodeTimeoutKey, smsTimeout])

    const _requestPasswordRecoverySMS = useCallback(async () => {
        console.log(smsTimeout)
        if (!sentSMSAt || (new Date().getTime() - sentSMSAt.getTime()) / 1000 > smsTimeout) {
            const data = await requestPasswordRecoverySMS(physicalID);
            console.log('data', data);
            if (data.status === 200) {
                setSentSMSAt(new Date());
            }
            setSMSTimeout(data.data.data);
            if (smsCodeTimeoutKey) {
                clearTimeout(smsCodeTimeoutKey)
            }
            const key = setTimeout(() => {
                setSentSMSAt(false)
            }, data.data.data * 1000);
            setSMSCodeTimeoutKey(key);
        }
    }, [physicalID, requestPasswordRecoverySMS, sentSMSAt, smsCodeTimeoutKey, smsTimeout])

    const startResetPasswordProcess = useCallback(async () => {
        const pID = physicalID;
        _requestPasswordRecoverySMS(pID);
        nullifyValues();
        setPhysicalID(pID);
        setResettingPassword(true);
    }, [_requestPasswordRecoverySMS, nullifyValues, physicalID])

    const resetPassword = useCallback(async () => {
        console.log(smsCode, password, repeatPassword);
        const authRes = await authPasswordRecovery(physicalID, smsCode);
        console.log('authRes', authRes)
        if(authRes.status === 0){
            const changeRres = await firstPasswordChange(password, repeatPassword);
            console.log('changeRes', changeRres) 
             nullifyValues();
        } else if (authRes.error === "SMS_VERIFY_ERROR") {
            setSMSCodeErorr(STRINGS.errors.wrongSMSCode)
        }
    }, [STRINGS.errors.wrongSMSCode, authPasswordRecovery, firstPasswordChange, nullifyValues, password, physicalID, repeatPassword, smsCode])

    const fields = useMemo(() => [
        {
            backendName: 'personal_id',
            component: TextFieldWithStatus,
            label: STRINGS.personalId,
            showIf: !resettingPassword,
            validate: async (val) => {
                if (physicalIDError) {
                    setPhysicalIDError('');
                }
                if (val.length === 11) {
                    setPhysicalIDStatus('loading');
                    try {
                        let { data: { status } } = await checkAuthState(val);
                        // status = 1;
                        console.log("Status", status, authState, STRINGS.errors);
                        setAuthState(status);

                        // const sms = await sendSMS(val);
                        // console.log("SMS", sms);
                        switch (status) {
                            case 0:
                                // await _sendSMS(val);
                                return 'success';
                            case 1:
                                await _sendSMS(val);
                                return 'success';

                            case 2:

                                setPhysicalIDError(STRINGS.errors.accountNotActivated)
                                return;

                            case 3:
                                setPhysicalIDError(STRINGS.errors.physicalIDNotFound);
                                setAuthState(3);
                                return 'fail';
                            default:
                                break;
                        }
                    } catch (error) {
                        setPhysicalIDError(STRINGS.errors.physicalIDNotFound)
                        setAuthState(3)
                        return "fail";
                    }

                }
            },
            value: physicalID,
            status: physicalIDStatus,
            success: STRINGS.correctPhysicalID,
            error: physicalIDError,
            setValue: setPhysicalID,
            setStatus: setPhysicalIDStatus,
            inputProps: { maxLength: 11 },
            bottom: <>
                {
                    physicalIDError ? <Typography className={classNames(classes.error, authState === 2 ? classes.dimError : null)}>
                        {physicalIDError}
                    </Typography> : null
                }
                {
                    authState === 2 ? <Button className={classes.goToMainPageButton} onClick={() => {
                        nullifyValues();
                        onClose();
                        history.push('/');
                    }}>
                        <Typography className={classes.goToMainPageButtonText}>{STRINGS.mainPage}</Typography>
                    </Button>
                        : null
                }
                {
                    authState === 3 ? <Button className={classes.registerButton} onClick={() => {
                        nullifyValues();
                        onClose();
                        // Redirecting for now
                        // history.push('/register');
                        let isMobile = false;
                        //eslint-disable-next-line
                        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
                        window.open(`https://www.lider-bet.com/${isMobile ? 'm' : 'web'}/ka/promotions?page=leadercard`, '_blank')
                    }}>
                        <Typography className={classes.registerButtonText}>{STRINGS.register}</Typography>
                    </Button>
                        : null
                }
            </>
        },
        {
            backendName: 'card_last_numbers',
            component: TextFieldWithStatus,
            label: STRINGS.cardLastFourNumbers,
            showIf: physicalIDStatus === 'success' && authState === 1,
            validate: (val) => {
                if (setCardLastFourNumbersError) {
                    setCardLastFourNumbersError('');
                }
                let restrictedVal = val.replace(/[^0-9]/g, '');
                setCardLastFourNumbers(restrictedVal);
                // return null;
            },
            value: cardLastFourNumbers,
            error: cardLastFourNumbersError,
            status: cardLastFourNumbersStatus,
            success: STRINGS.correctCardLastFourNumbers,
            setValue: setCardLastFourNumbers,
            setStatus: setCardLastFourNumbersStatus,
            inputProps: { maxLength: 4 },
            bottom: cardLastFourNumbersError ? <Typography className={classNames(classes.error, authState === 2 ? classes.dimError : null)}>
                {cardLastFourNumbersError}
            </Typography> : null

        },
        {
            backendName: 'password',
            component: TextFieldPassword,
            label: authState === 1 ? STRINGS.setPassword : STRINGS.password,
            showIf: resettingPassword || (physicalIDStatus === 'success' && authState === 1) || (physicalIDStatus === 'success' && authState === 0),
            validate: () => {
                if (passwordError) {
                    setPasswordError('');
                }
            },
            value: password,
            error: passwordError,
            setValue: setPassword,
            inputProps: { minLength: 6 },
            bottom: <>
                {
                    passwordError ? <>
                    <Typography className={classNames(classes.error, authState === 2 ? classes.dimError : null)}>
                        {passwordError}
                    </Typography>
                    </> : null
                }
                {authState === 0 ? <>
                    <Typography className={classNames(classes.resetPasswordPromptText)} onClick={startResetPasswordProcess}>
                        {STRINGS.resetPasswordPrompt}
                    </Typography>
                </> : null}
                {authState === 0 && !userData ? <Button disabled={!(password.length >= 6) || currentlyRequesting} onClick={handleLogin} className={classes.setPasswordButton}>
                    <Typography className={classes.setPasswrodButtonText}>
                        {STRINGS.loginButtonText}
                    </Typography>
                </Button> : null}
            </>
        },
        {
            backendName: 'repeatPassword',
            component: TextFieldPassword,
            label: STRINGS.repeatPassword,
            showIf: resettingPassword || (physicalIDStatus === 'success' && authState === 1),
            validate: () => {

            },
            value: repeatPassword,
            setValue: setRepeatPassword,
            inputProps: { minLength: 6 },
            bottom: <>
                { repeatPassword && password !== repeatPassword ? <Typography className={classNames(classes.error, authState === 2 ? classes.dimError : null)}>
                    {STRINGS.errors.passwordsNoMatch}
                </Typography> : null}
            </>
        },
        {
            backendName: 'sms_code',
            component: SMSInputWithStatus,
            label: STRINGS.smsCode,
            showIf: resettingPassword || (physicalIDStatus === 'success' && authState === 1) || (physicalIDStatus === 'success' && authState === 0 && userData),
            validate: (val) => {
                if (smsCodeError) {
                    setSMSCodeErorr('');
                }
                let restrictedVal = val.replace(/[^0-9]/g, '');
                setSMSCode(restrictedVal);
            },
            value: smsCode,
            error: smsCodeError,
            status: smsCodeStatus,
            setValue: setSMSCode,
            setStatus: setSMSCodeStatus,
            sentSMSAt: sentSMSAt,
            setCanSendSMS: setSentSMSAt,
            sendSMS: resettingPassword ? () => (_requestPasswordRecoverySMS(physicalID)) : authState === 0 ? verify : _sendSMS,
            timeoutSecs: smsTimeout,
            inputProps: { maxLength: 4 },
            bottom: <>
                {
                    smsCodeError ? <Typography className={classNames(classes.error)}>
                        {smsCodeError}
                    </Typography> : null
                }
                {authState === 0 && userData ? <Button disabled={!(password.length >= 6) || currentlyRequesting} onClick={() => verifyAuth(smsCode)} className={classes.setPasswordButton}>
                    <Typography className={classes.setPasswrodButtonText}>
                        {STRINGS.loginButtonText}
                    </Typography>
                </Button> : null}
                {authState === 1 ? <Button disabled={!(password.length >= 6 && password === repeatPassword && smsCode.length === 4 && cardLastFourNumbers.length === 4) || currentlyRequesting} onClick={handleFirstTimeLogin} className={classes.setPasswordButton}>
                    <Typography className={classes.setPasswrodButtonText}>
                        {STRINGS.setPasswordButtonText}
                    </Typography>
                </Button> : null}
                {resettingPassword ? <Button disabled={!(password.length >= 6 && password === repeatPassword && smsCode.length === 4) || currentlyRequesting} onClick={resetPassword} className={classes.setPasswordButton}>
                    <Typography className={classes.setPasswrodButtonText}>
                        {STRINGS.resettingPasswordButtonText}
                    </Typography>
                </Button> : null}
            </>
        },
    ], [STRINGS.personalId, STRINGS.correctPhysicalID, STRINGS.mainPage, STRINGS.register, STRINGS.cardLastFourNumbers, STRINGS.correctCardLastFourNumbers, STRINGS.setPassword, STRINGS.password, STRINGS.resetPasswordPrompt, STRINGS.loginButtonText, STRINGS.repeatPassword, STRINGS.errors, STRINGS.smsCode, STRINGS.setPasswordButtonText, STRINGS.resettingPasswordButtonText, resettingPassword, physicalID, physicalIDStatus, physicalIDError, classes.error, classes.dimError, classes.goToMainPageButton, classes.goToMainPageButtonText, classes.registerButton, classes.registerButtonText, classes.resetPasswordPromptText, classes.setPasswordButton, classes.setPasswrodButtonText, authState, cardLastFourNumbers, cardLastFourNumbersError, cardLastFourNumbersStatus, password, passwordError, startResetPasswordProcess, userData, currentlyRequesting, handleLogin, repeatPassword, smsCode, smsCodeError, smsCodeStatus, sentSMSAt, verify, _sendSMS, smsTimeout, handleFirstTimeLogin, resetPassword, checkAuthState, nullifyValues, onClose, history, _requestPasswordRecoverySMS, verifyAuth]);


    const renderFields = () => {
        const elements = [];
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            if (typeof field.showIf === 'boolean' && !field.showIf) {
                continue
            }
            elements.push(
                <Grid key={field.backendName} xs={12} item className={classes.textFieldContainer}>
                    <field.component {...field} />
                    {field.bottom}
                </Grid>
            )
        }
        return elements
    }

    return (
        <Modal
            open={isOpen}
        >
            <Grid container className={classes.container} alignItems="baseline">
                <ModalCloseSVGR className={classes.closeSVGR} onClick={() => {
                    nullifyValues();
                    onClose();
                }} />
                <Grid xs={12} item className={classes.titleContainer}>
                    <Typography variant="h2" className={classes.title}>
                        {STRINGS.title}
                    </Typography>
                </Grid>
                {renderFields()}
            </Grid>
        </Modal>
    );
};

export default Header;
